import { useQueryClient } from '@tanstack/react-query'

export function useInvalidateCommissions() {
  const qc = useQueryClient()
  return () =>
    qc.invalidateQueries({
      predicate: (q) =>
        typeof q.queryKey[0] === 'string' &&
        q.queryKey[0].startsWith('/api/commercial-commissions'),
    })
}
